// Vite inlines only statically named keys; a dynamic import.meta.env lookup bundles every VITE_ var.
const env = {
  get VITE_SO_CHAT_WIDGET_LOADER() {
    return import.meta.env.VITE_SO_CHAT_WIDGET_LOADER
  },
  get VITE_SHOW_COT_METER_READING() {
    return import.meta.env.VITE_SHOW_COT_METER_READING
  },
}

const get = (envVar: keyof typeof env) => {
  return env[envVar]
}

const isActive = (envVar: keyof typeof env) => {
  return env[envVar] === "true"
}

export default { get, isActive }
